import React, { useState } from "react";
import "./ContactFAQ.css";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const faqData = [
  {
    question: "How quickly will your team respond?",
    answer:
      "Our team typically responds within 24 business hours. For urgent inquiries, WhatsApp is the fastest way to connect with us.",
  },
  {
    question: "Do you work with international clients?",
    answer:
      "Yes. We work with clients globally through our India and Dubai operations, supporting different time zones efficiently.",
  },
  {
    question: "Is my project information kept confidential?",
    answer:
      "Absolutely. We follow strict data confidentiality practices and are NDA-ready for all client engagements.",
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "We work across multiple industries including technology, healthcare, fintech, real estate, logistics, and enterprise solutions.",
  },
  {
    question: "Do you offer consultation before starting a project?",
    answer:
      "Yes. We offer a no-obligation consultation to understand your requirements and suggest the best technical approach.",
  },
];

const ContactFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="oglitz-faq">
      <div className="oglitz-faq-container">
        {/* HEADER */}
        <div className="oglitz-faq-header">
          <span className="oglitz-faq-badge">FAQs</span>
          <h2>
            Frequently Asked <span>Questions</span>
          </h2>
          <p>
            Clear answers to common questions before you reach out to our team.
          </p>
        </div>

        {/* FAQ LIST */}
        <div className="oglitz-faq-list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`oglitz-faq-item ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="oglitz-faq-question">
                <h4>{item.question}</h4>
                <span className="oglitz-faq-icon">
                  {activeIndex === index ? <RemoveIcon /> : <AddIcon />}
                </span>
              </div>

              <div className="oglitz-faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactFAQ;
